import { AxiosPromise } from 'axios';

import { ExplainResponse, ExplainSubjectKind } from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

const authHeaders = () => ({
  Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
});

/**
 * Пояснение по болезни для человека (people) или питомца (pet).
 * signal позволяет отменить запрос при закрытии панели.
 */
export const getExplain = async (
  kind: ExplainSubjectKind,
  subjectId: string,
  diseaseId: string,
  signal?: AbortSignal,
): AxiosPromise<ExplainResponse> =>
  apiInstance.get(`/${kind}/${subjectId}/${diseaseId}/explain`, {
    headers: authHeaders(),
    signal,
  });
